import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import NewsListPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import AnimeListPage from "@/pages/anime/page";
import AnimeDetailPage from "@/pages/anime/detail/page";
import AboutPage from "@/pages/about/page";
import SearchPage from "@/pages/search/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsListPage /> },
      { path: "news/detail/:id", element: <NewsDetailPage /> },
      { path: "anime", element: <AnimeListPage /> },
      { path: "anime/detail/:id", element: <AnimeDetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;